import React, { useContext } from 'react';
import { LanguageContext } from './LanguageContext';

const messages = {
    ru: {
        company: 'UNITECH',
        copyright: 'Все права защищены.',
    },
    kg: {
        company: 'UNITECH',
        copyright: 'Бардык укуктар корголгон.',
    },
};

export default function Footer() {
    const { language } = useContext(LanguageContext);
    const current = messages[language] || messages.ru;

    return (
        <footer className="bg-black py-1 text-center">
            <div className="text-white text-xs leading-none">
                <strong>{current.company}</strong> &copy; {new Date().getFullYear()} — {current.copyright}
            </div>
        </footer>
    );
}
